export const ADD_ABHA_RECORD = "/abha/v1/add-consent";
export const GET_ABHA_CONSENT = "/abha/v1/get-consent";
export const GET_GRANTED_DOCUMENTS = (details) =>
  `abha/v1/get-bundle/${details?.consentRequestId}`;
